import { TInitialState } from "./contextTypes";

export const initialState: TInitialState = {
  isVisible: false,
  type: "error",
  message: ""
};